
import {useSelector} from 'react-redux'
import { RootState } from "../../../setup/redux/RootReducer";
import {useState, useEffect} from 'react' 
import {GetDistrictList, GetQuarterList} from './redux/CountryOperations'
import {PostCustomerForSms, PostCustomerForUpdate, PostCustomerToMcfm, MugeOutRequest} from './redux/CustomerOperations'
import {District, Quarter} from './models/RegionModels'
import NumberFormat from 'react-number-format';



export default  function UpdateCustomerPage():JSX.Element {

    const customer = useSelector((state: RootState) => state.customerDetailReducer);
    const initialValues = {
      boolValues:false,
      stringValues:""
    };

    console.log("initial val",initialValues)

    useEffect(() => {
      setCustomerState(customer.customerDetailItem);
        console.log("23 CustomerState ", customerState);     
        setErrorString(initialValues.stringValues);
        setSuccessString(initialValues.stringValues);
        setAdddressTypeErr(initialValues.stringValues);
        setAddressEdit(initialValues.boolValues);
        setSendLinkLoading(initialValues.boolValues);
        setUpdateDataLoading(initialValues.boolValues);
        setSaveDataLoading(initialValues.boolValues);
        setDisableMugeClickLoading(initialValues.boolValues);
   },[customer]);

 
   const [customerState, setCustomerState] = useState(customer.customerDetailItem);


    const [errorString, setErrorString] = useState(initialValues.stringValues);

    const [adddressTypeErr, setAdddressTypeErr] = useState(initialValues.stringValues);
    const [successString, setSuccessString] = useState(initialValues.stringValues);
    const [defaultAddressType, setDefaultAddressType] = useState("R");

    const [addresEdit, setAddressEdit] = useState(initialValues.boolValues);
    const [sendLinkLoading, setSendLinkLoading] = useState(initialValues.boolValues);
    const [updateDataLoading, setUpdateDataLoading] = useState(initialValues.boolValues);
    const [saveDataLoading, setSaveDataLoading] = useState(initialValues.boolValues);
    const[disableMugeClickLoading, setDisableMugeClickLoading] = useState(initialValues.boolValues);
    const [dateWarningModal, setDateWarningModal] = useState<boolean>(customerState.DateWarning);


    const [districtList, setDistrictList] = useState<District[]>();
    const [quarterList, setquarterList] = useState<Quarter[]>();

    // useEffect(() => {
    //   console.log("customerstate değişikliği");
     
    // },[customerState])
 

    const EditAdress = (status:boolean) => {
        setAddressEdit(status);
    }
    
    const closeRegionBox = () => {
        EditAdress(false);
    }
    
    const disableMugeClick = async () => {
      setDisableMugeClickLoading(true);
      setErrorString("");
      setAdddressTypeErr("");

      let response:any = await MugeOutRequest(customerState?.PrmCustomerGuid);
      console.log("Response =>", response);
      if(response.data != null){
        if(response.data.Status !="SUCCESS"){
          setErrorString(response.data.Detail);
        }else{
          setSuccessString("Müşteri mügeden çıkarılmıştır.");
        }
      }else{
        setErrorString("Servis bağlantısı kurulamadı");
        setDisableMugeClickLoading(false)
      }
      setDisableMugeClickLoading(false);
    }

    const sendLinkClick = async () => {
      setSendLinkLoading(true);
      setErrorString("");
      setAdddressTypeErr("");
      let errors= "";
      console.log("Link gönder => ",customerState)
      if ((addresEdit && (customerState.Mahalle_Id == undefined || customerState.Mahalle_Id == "0")
                     && (customerState.Ilce_Id == undefined || customerState.Ilce_Id == "0"))){
        errors = "İlçe ve mahalle bilgisi boş geçilemez.</br>";
      }
      if((customerState.AddressTypeCd == undefined || customerState.AddressTypeCd == "0" && defaultAddressType !=="R")){
        // errors+="Lütfen adres tipi seçiniz.</br>";
        // setAdddressTypeErr("Adres tipi zorunludur");
        setDefaultAddressType("R");
        setCustomerState(prevState => ({
          ...prevState,
          AddressTypeCd:"R"
        }));
      }
      setErrorString(errors);

      if(errors === ""){
        let response:any = await PostCustomerForSms(customerState);
        console.log("Response =>", response);
        if(response.data != null){
          if(response.data.Status !="SUCCESS"){
            setErrorString(response.data.Detail);
          }else{
            setCustomerState(prevState => ({
              ...prevState,
              CustomerGuid:response.data.Detail
            }));
            setSuccessString("Mesaj başarıyla gönderildi");
          }
        }else{
          setErrorString("Servis bağlantısı kurulamadı");
          setSendLinkLoading(false)
        }
      }
      setSendLinkLoading(false)
      console.log("User =>",customerState);
    }
    
    const updateData = async () => {
        setUpdateDataLoading(true);
        setErrorString("");
        setAdddressTypeErr("");
        let errors= "";
        console.log("update data => ",customerState);
        if ((addresEdit && (customerState.Mahalle_Id == undefined || customerState.Mahalle_Id == "0")
          && (customerState.Ilce_Id == undefined || customerState.Ilce_Id == "0"))){
          errors = "İlçe ve mahalle bilgisi boş geçilemez.</br>";
        }
        if((customerState.AddressTypeCd == undefined || customerState.AddressTypeCd == "0" && defaultAddressType !== "R")){
          setDefaultAddressType("R")
          // errors+="Lütfen adres tipi seçiniz.</br>";
          // setAdddressTypeErr("Adres tipi zorunludur");
          setCustomerState(prevState => ({
            ...prevState,
            AddressTypeCd:"R"
          }));
        }
        if((customerState.CustomerGuid == undefined || customerState.CustomerGuid == "00000000-0000-0000-0000-000000000000")){
          errors+="Lütfen kayıt işleminden önce mesaj gönderiniz";
        }
        setErrorString(errors);

        console.log("MCFM'e Gonder =>" ,customerState);
        if(errors === ""){
          let response:any = await PostCustomerToMcfm(customerState);
          console.log("Response =>", response);
          if(response.data != null){
            if(response.data.Status !="SUCCESS"){
              setErrorString(response.data.Detail);
            }else{
              setSuccessString("Veriler MCFM'e gönderildi.");
            }
          }else{
            setErrorString("Servis bağlantısı kurulamadı");
            setSaveDataLoading(false)
          }
        }

        setUpdateDataLoading(false);
    }

    const handleAddressType = (e:any) => {
      const {name, value} = e.target;
      setDefaultAddressType(value);
      setCustomerState(prevState => ({
        ...prevState,
        AddressTypeCd: value
      }));
    }

    const saveData = async () => {
      setSaveDataLoading(true);
      setErrorString("");
      setAdddressTypeErr("");
      let errors= "";
      console.log("update data => ",customerState);
      if ((addresEdit && (customerState.Mahalle_Id == undefined || customerState.Mahalle_Id == "0")
        && (customerState.Ilce_Id == undefined || customerState.Ilce_Id == "0"))){
        errors = "İlçe ve mahalle bilgisi boş geçilemez.</br>";
      }
      if((customerState.AddressTypeCd == undefined || customerState.AddressTypeCd == "0" && defaultAddressType !== "R")){
        // errors+="Lütfen adres tipi seçiniz.</br>";
        // setAdddressTypeErr("Adres tipi zorunludur");
        setDefaultAddressType("R");
        setCustomerState(prevState => ({
          ...prevState,
          AddressTypeCd:"R"
        }));
      }
      if((customerState.CustomerGuid == undefined || customerState.CustomerGuid == "00000000-0000-0000-0000-000000000000")){
        errors+="Lütfen kayıt işleminden önce mesaj gönderiniz";
      }
      setErrorString(errors);

      if(errors === ""){
        let response:any = await PostCustomerForUpdate(customerState);
        console.log("Response =>", response);
        if(response.data != null){
          if(response.data.Status !="SUCCESS"){
            setErrorString(response.data.Detail);
          }else{
            setSuccessString("Bilgiler başarıyla güncellendi");
          }
        }else{
          setErrorString("Servis bağlantısı kurulamadı");
          setSaveDataLoading(false)
        }
      }
       setSaveDataLoading(false);
    }

    const handleOption = (e:any,statu:boolean) => {
      const {name, value} = e.target;
      console.log("Name =>",name);
      console.log("Statu =>",statu);
      console.log("handleOption==>",customer.customerDetailItem);
         setCustomerState(prevState => ({
             ...prevState,
             [name]: statu
         }));
        console.log("local state 78 =>",customerState);
    }

    const handleIput = (e:any) => {
      const {name, value} = e.target;
      console.log("Name =>",name);
      console.log("Value =>",value);
      console.log("handleOption==>",customer.customerDetailItem);
      setCustomerState(prevState => ({
        ...prevState,
        [name]: value
      }));
      console.log("local state 99 =>",customerState);
    }

    async function  handleChangeDistrict(e:any)  {
        const {name, value} = e.target;
        console.log("target =>>",e);
      console.log("Value =>>",name);

        if(value == "0"){
            setErrorString("Lütfen bir ilçe seçiniz.");
        }else{
            let response:any = await GetQuarterList(value);
            console.log("Response =>", response);
            if(response.data != null){
                if(response.data.Status !="SUCCESS"){
                    setErrorString(response.data.Detail);

                }else{
                  setCustomerState(prevState => ({
                    ...prevState,
                    Ilce_Id:value
                  }));
                    setquarterList(response.data.Detail)
                }
            }else{
                setErrorString("Servis bağlantısı kurulamadı");
            }
        }
    }

    async function  handleChangeTown(e:any)  {
        const {name, value} = e.target;
        console.log("Value =>>",value);

        setquarterList(undefined);

        if(value == "0"){
            setErrorString("Lütfen bir il seçiniz.");
        }else{
            let response:any = await GetDistrictList(value);
            console.log("Response =>", response);
            if(response.data != null){
                if(response.data.Status !="SUCCESS"){
                    setErrorString(response.data.Detail);
                }else{
                    setDistrictList(response.data.Detail)
                }
            }else{
                setErrorString("Servis bağlantısı kurulamadı");
            }
        }
    }

    async function  handleChangeQuarter(e:any)  {
    const {name, value} = e.target;
    setCustomerState(prevState => ({
      ...prevState,
      Mahalle_Id:value
    }));
    }

  return  <> {
        customer.customerDetailItem  != null && customer.customerDetailItem["CUST_NO"] != "" &&
        <div className={`card card-xxl-stretch`} style={{height:'auto'}}>
        {/* begin::Header */}
        <div className='card-header align-items-center border-0 mt-4' style={{display:'block',overflow:'scroll'}}>
        <h3 className='card-title align-items-start flex-column'>
            <span className='fw-bolder mb-2 text-dark' style={{textDecorationLine:'underline',fontStyle:'italic'}}>Firma Bilgileri</span>
        </h3>
        <div className='card-toolbar'>

          {  customerState.DateWarning  && dateWarningModal &&
            <div className="modal fade show" tabIndex={-1} id="modal" style={{display: 'block'}}  aria-modal="true" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header"><h5 className="modal-title">Dikkat</h5>
                  </div>
                  <div className="modal-body"><p>Bu kayıt 01/10/2020 tarihinden önce açılmış.</p></div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={() => setDateWarningModal(false)}>Kapat</button>
                  </div>
                </div>
              </div>
            </div>
          }
        
            <div className='card-body pt-5' style={{paddingLeft:0,marginBottom:15}}>
                {/* <input type="file" name="file" onChange={changeHandler} /> */}
                <div className="row gy-5 g-xl-8">
                  { successString != "" &&
                    <div className="alert alert-dismissible bg-success d-flex flex-column flex-sm-row p-5 mb-10"><span
                      className="svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0"><span
                      className="svg-icon svg-icon-2hx svg-icon-light me-4 mb-5 mb-sm-0">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                           className="mh-50px"><path opacity="0.3"  d="M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z"
                                                     fill="black"></path><path
                        d="M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z"
                        fill="black"></path></svg></span></span>
                        <div className="d-flex flex-column text-light pe-0 pe-sm-10"><h5 className="mb-1" style={{color:'white'}}>Başarılı</h5>
                          <span>{successString}</span>
                        </div>
                        <button type="button"
                                className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                                data-bs-dismiss="alert"
                                onClick={() => setSuccessString("")}>
                          <span className="svg-icon svg-icon-2x svg-icon-light"><span
                          className="svg-icon svg-icon-2x svg-icon-light">
                          <svg width="24" height="24" viewBox="0 0 24 24"
                                                                               fill="none"
                                                                               xmlns="http://www.w3.org/2000/svg"
                                                                               className="mh-50px"><rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black"></rect><rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black"></rect></svg></span></span></button>
                      </div>
                  }

                 {errorString != "" && errorString != null &&  <div className="col-xxl-12">
                        <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                            <span className="svg-icon svg-icon-2hx svg-icon-danger me-3">
                                <span className="svg-icon svg-icon-2hx svg-icon-danger me-4">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mh-50px">
                                        <path opacity="0.3" d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z" fill="black"></path>
                                        <path d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z" fill="black"></path>
                                    </svg>
                                </span>
                            </span>
                            <div className="d-flex flex-column">
                                <h5 className="mb-1">Dikkat</h5>
                                <span dangerouslySetInnerHTML={{__html:errorString}}></span>
                            </div>
                        </div>
                </div>}
                    

                     <div className="col-xxl-8">
                    </div>
                    <div className="col-xxl-3">
                           <span style={{display:'inline',fontSize:16, color:customerState?.DateWarning ? 'red' : 'black'}}>Kayıt Tarihi: {customerState?.KayitTarihiStr}</span>
                    </div>
                    <div className="col-xxl-1">
                    </div>



                    <div className="col-xxl-2">
                        <div>
                            <p style={{margin:0,paddingTop:8}}>
                                   <label className="form-label">Cep Tel:</label>
                            </p>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <NumberFormat type="text"
                                      format="+##(###)-###-####"
                                      mask=""
                                      className="form-control"
                                      value={customerState?.MOBILE_PHONE_NO}
                                      style={{padding:"0.40em 0.75em"}}
                                      name="MOBILE_PHONE_NO" onChange={(event) => handleIput(event)}
                        />
                    </div>

                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                             <label className="form-label">E-posta</label> 
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control"
                               defaultValue={customerState?.EMAIL_ADDRESS}  style={{padding:"0.40em 0.75em"}}
                               name="EMAIL_ADDRESS" onChange={(event) => handleIput(event)}
                        />
                    </div>
                    <div className="col-xxl-1">
                    </div>


                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                             <label className="form-label">Müşteri No:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control" style={{padding:"0.40em 0.75em"}} value={customerState?.STORE_KEY + "-" + customerState?.CUST_NO} disabled={true}/>
                    </div>

                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                           <label className="form-label">Firma Unvanı </label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control"  style={{padding:"0.40em 0.75em"}} value={customerState?.KISAAD_TICARI} disabled={true}/>
                    </div>
                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                           <label className="form-label">Vergi No:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control" style={{padding:"0.40em 0.75em"}} value={customerState?.VERGI_NO}  disabled={true}/>
                    </div>

                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                        <label className="form-label"> Sabit Tel </label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <NumberFormat type="text"
                                      format="+##(###)-###-####"
                                      mask=""
                                      className="form-control"
                                      style={{padding:"0.40em 0.75em"}}
                                      value={customerState?.PHONE_NO}
                                      name="PHONE_NO" onChange={(event) => handleIput(event)}
                        />
                    </div>
                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                            <label className="form-label">Satın Alma Yetkilisi Adı:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control" style={{padding:"0.40em 0.75em"}}
                               value={customerState?.AD_UNVAN2} 
                               disabled={customerState?.Kurumsal && customerState?.AUTH_PERSON_ID == "0"}
                               name="AD_UNVAN2" onChange={(event) => handleIput(event)}/>
                    </div>

                    <div className="col-xxl-1">
                    </div>



                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                            <label className="form-label">Satın Alma Yetkilisi Soyadı:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control" style={{padding:"0.40em 0.75em"}} 
                               value={customerState?.SOYAD_UNVAN} 
                               disabled={customerState?.Kurumsal && customerState?.AUTH_PERSON_ID == "0"}
                               name="SOYAD_UNVAN" onChange={(event) => handleIput(event)}/>
                    </div>


                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                            <label className="form-label">Yasal Yetkili:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3" >
                        <input type="text" className="form-control" style={{padding:"0.40em 0.75em"}} value={customerState?.YasalYetkili ? "Evet" : "Hayır"}  disabled={true}/>
                    </div>

                    <div className="col-xxl-1">
                    </div>

                    <div className="col-xxl-2">
                        <div style={{margin:0,paddingTop:8}}>
                            <label className="form-label">Müge:</label>
                        </div>
                    </div>
                    <div className="col-xxl-3">
                        {customerState?.IsHaveMUGE ? 
                          <button className="btn btn-primary p-3" onClick={disableMugeClick} disabled={disableMugeClickLoading} style={{fontWeight:'normal'}}>
                        
                          {!disableMugeClickLoading && <span className='indicator-label'>Mügeden Çıkar</span>}
                          {disableMugeClickLoading && (
                              <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                              Lütfen bekleyiniz...
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                          )} 
                      </button>
                          :<span>Müge kaydı bulunmuyor.</span>}
                    </div>

                    <h3 className='card-title align-items-start flex-column  mt-20'>
                        <span className='fw-bolder mb-2 text-dark ' style={{textDecorationLine:'underline',fontStyle:'italic',position:'relative'}}>
                          Adres Bilgileri
                          <svg onClick={() => EditAdress(true)} style={{cursor:'pointer',height:'12',color:'#66abc5',marginLeft:7,position:'absolute',top:'10%',right:'-19%',display: addresEdit ? 'none' : 'inherit'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-fill" viewBox="0 0 16 16">
                            <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" onClick={closeRegionBox} style={{color:'red',height:'100%',cursor:'pointer',position:'absolute',top:'2%',right:'-21%',display: !addresEdit ? 'none' : 'inherit'}} width="16" height="16" fill="currentColor" className="bi bi-x-octagon" viewBox="0 0 16 16">
                             <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353L4.54.146zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1H5.1z"/>
                             <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </span>
                    </h3>


                    <div className="col-xxl-12 mt-1" style={{display: addresEdit ? 'none' : 'block' }}>
                        <> <b>İlçe:</b> {customerState?.SEMT} <br/>
                           <b>Mahalle:</b> {customerState?.MAHALLE}<br/>
                           <b>Cadde:</b> {customerState?.CADDE}<br/>
                           <b>Sokak:</b> {customerState.SOKAK}<br/>
                           <b>Bina No:</b> {customerState.BINA_NO} <br/>
                           <b>Bina Adı:</b> {customerState.BINA_ADI} <br/>
                           <b>Kapı No:</b> {customerState.KAPI_NO} <br/>

                        </>
                    </div>

                    <div className="col-xxl-12 row" style={{display: !addresEdit ? 'none' : 'inherit' }}>
                        <div className="col-xxl-2">
                            <select className="form-select" aria-label="Select example" onChange={handleChangeTown} style={{padding:"0.40em 0.75em"}}>
                                <option value="0">İl Seçiniz</option>
                                <option value="1">ADANA</option>
                                <option value="2">ADIYAMAN</option>
                                <option value="3">AFYONKARAHİSAR</option>
                                <option value="4">AĞRI</option>
                                <option value="68">AKSARAY</option>
                                <option value="5">AMASYA</option>
                                <option value="6">ANKARA</option>
                                <option value="7">ANTALYA</option>
                                <option value="75">ARDAHAN</option>
                                <option value="8">ARTVİN</option>
                                <option value="9">AYDIN</option>
                                <option value="10">BALIKESİR</option>
                                <option value="74">BARTIN</option>
                                <option value="72">BATMAN</option>
                                <option value="69">BAYBURT</option>
                                <option value="11">BİLECİK</option>
                                <option value="12">BİNGÖL</option>
                                <option value="13">BİTLİS</option>
                                <option value="14">BOLU</option>
                                <option value="15">BURDUR</option>
                                <option value="16">BURSA</option>
                                <option value="17">ÇANAKKALE</option>
                                <option value="18">ÇANKIRI</option>
                                <option value="19">ÇORUM</option>
                                <option value="20">DENİZLİ</option>
                                <option value="21">DİYARBAKIR</option>
                                <option value="81">DÜZCE</option>
                                <option value="22">EDİRNE</option>
                                <option value="23">ELAZIĞ</option>
                                <option value="24">ERZİNCAN</option>
                                <option value="25">ERZURUM</option>
                                <option value="26">ESKİŞEHİR</option>
                                <option value="27">GAZİANTEP</option>
                                <option value="28">GİRESUN</option>
                                <option value="29">GÜMÜŞHANE</option>
                                <option value="30">HAKKARİ</option>
                                <option value="31">HATAY</option>
                                <option value="76">IĞDIR</option>
                                <option value="32">ISPARTA</option>
                                <option value="34">İSTANBUL</option>
                                <option value="35">İZMİR</option>
                                <option value="46">KAHRAMANMARAŞ</option>
                                <option value="78">KARABÜK</option>
                                <option value="70">KARAMAN</option>
                                <option value="36">KARS</option>
                                <option value="37">KASTAMONU</option>
                                <option value="38">KAYSERİ</option>
                                <option value="71">KIRIKKALE</option>
                                <option value="39">KIRKLARELİ</option>
                                <option value="40">KIRŞEHİR</option>
                                <option value="79">KİLİS</option>
                                <option value="41">KOCAELİ</option>
                                <option value="42">KONYA</option>
                                <option value="43">KÜTAHYA</option>
                                <option value="44">MALATYA</option>
                                <option value="45">MANİSA</option>
                                <option value="47">MARDİN</option>
                                <option value="33">MERSİN</option>
                                <option value="48">MUĞLA</option>
                                <option value="49">MUŞ</option>
                                <option value="50">NEVŞEHİR</option>
                                <option value="51">NİĞDE</option>
                                <option value="52">ORDU</option>
                                <option value="80">OSMANİYE</option>
                                <option value="53">RİZE</option>
                                <option value="54">SAKARYA</option>
                                <option value="55">SAMSUN</option>
                                <option value="56">SİİRT</option>
                                <option value="57">SİNOP</option>
                                <option value="58">SİVAS</option>
                                <option value="63">ŞANLIURFA</option>
                                <option value="73">ŞIRNAK</option>
                                <option value="59">TEKİRDAĞ</option>
                                <option value="60">TOKAT</option>
                                <option value="61">TRABZON</option>
                                <option value="62">TUNCELİ</option>
                                <option value="64">UŞAK</option>
                                <option value="65">VAN</option>
                                <option value="77">YALOVA</option>
                                <option value="66">YOZGAT</option>
                                <option value="67">ZONGULDAK</option>
                            </select>
                        </div>

                        <div className="col-xxl-2">
                            <select className="form-select" aria-label="Select example" id="ilceSelect" onChange={(event) =>handleChangeDistrict(event)} style={{padding:"0.40em 0.75em"}}>
                             <option value="0">İlçe Seçiniz</option>
                                {
                                    districtList?.map(district => (
                                        <option value={district.DistrictId}>{district.Name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="col-xxl-2">
                            <select className="form-select" aria-label="Select example" onChange={(event) =>handleChangeQuarter(event)}  id="mahSelect" style={{padding:"0.40em 0.75em"}}>
                                <option value="0">Mahalle Seçiniz</option>
                                {
                                    quarterList?.map(quarter => (
                                        <option value={quarter.QuarterId}>{quarter.Name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="col-xxl-2" style={{padding:0}}>

                        </div>
                      <div className="col-xxl-4" style={{padding:0}}>
                        </div>


                      <div className="col-xxl-3 mt-5">
                        <label className="form-label">Cadde</label>
                        <input type="text" className="form-control" name="CADDE" onChange={(event) => handleIput(event)} defaultValue={customerState?.CADDE} style={{padding:"0.40em 0.75em",width:"73%"}} />
                      </div>

                      <div className="col-xxl-3 mt-5">
                        <label className="form-label">Sokak</label>
                        <input type="text" className="form-control" name="SOKAK" onChange={(event) => handleIput(event)} defaultValue={customerState?.SOKAK}  style={{padding:"0.40em 0.75em",width:"73%"}} />
                      </div>

                      <div className="col-xxl-3 mt-5">
                        <label className="form-label">Kapı No</label>
                        <input type="text" className="form-control" name="KAPI_NO" onChange={(event) => handleIput(event)} defaultValue={customerState?.KAPI_NO}  style={{padding:"0.40em 0.75em",width:"73%"}} />
                      </div>

                      <div className="col-xxl-3 mt-5">
                        <label className="form-label">Bina Adı</label>
                        <input type="text" className="form-control" name="BINA_ADI" onChange={(event) => handleIput(event)} defaultValue={customerState?.BINA_ADI}   style={{padding:"0.40em 0.75em",width:"73%"}}/>
                      </div>



                      <div className="col-xxl-3 mt-5">
                        <label className="form-label">Bina No</label>
                        <input type="text" className="form-control" name="BINA_NO" onChange={(event) => handleIput(event)} defaultValue={customerState?.BINA_NO} style={{padding:"0.40em 0.75em",width:"73%"}} />
                      </div>
                      <div className="col-xxl-3 mt-5">
                        <label style={{marginBottom:0}} className="form-label">Adres tipi</label>
                        {adddressTypeErr != "" && <label style={{color:'red',display:'block'}}>{adddressTypeErr}</label>}
                        <select style={{width:'73%',padding:"0.40em 0.75em"}} value={defaultAddressType} className="form-select" aria-label="Select example" id="ilceSelect" onChange={(event) => handleAddressType(event)}>
                          <option value="0">Adres Tipi Seçiniz</option>
                          <option value="L">Şirket</option>
                          <option value="W">MetroPost</option>
                          <option value="R" >Fatura</option>
                        </select>
                      </div>


                    </div>

                    <h3 className='card-title align-items-start flex-column  mt-20'>
                        <span className='fw-bolder mb-2 text-dark ' style={{textDecorationLine:'underline',fontStyle:'italic'}}>İletişim İzinleri</span>
                    </h3>
           
                    <div className="col-xxl-3">
                        <div className="form-check form-switch form-check-custom form-check-solid">
                            <input className="form-check-input" name="SmsIzni"
                                   type="checkbox" defaultValue="" id="flexSwitchChecked"
                                   onClick={(event) => handleOption(event,!customerState?.SmsIzni)}
                                   checked={customerState?.SmsIzni}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchChecked">
                                Telefon
                            </label>
                        </div>     
                    </div>     

                    {/* <div className="col-xxl-2">
                        <div className="form-check form-switch form-check-custom form-check-solid">
                            <input className="form-check-input" type="checkbox" defaultValue="" id="flexSwitchCheckedArama"
                                   name="AramaIzni" onClick={(event) => handleOption(event,!customerState?.AramaIzni)}
                                   checked={customerState.AramaIzni}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckedArama">
                                Arama
                            </label>
                        </div>     
                    </div>       */}
                    <div className="col-xxl-3">
                        <div className="form-check form-switch form-check-custom form-check-solid">
                            <input className="form-check-input" type="checkbox" defaultValue="" id="flexSwitchCheckedEposta"
                                   name="EpostaIzni" onClick={(event) => handleOption(event,!customerState?.EpostaIzni)}
                                   checked={customerState.EpostaIzni} />
                            <label className="form-check-label" htmlFor="flexSwitchCheckedEposta">
                                E-Posta
                            </label>
                        </div>     
                    </div>      

                    <div className="col-xxl-3">
                        <div className="form-check form-switch form-check-custom form-check-solid">
                            <input className="form-check-input" type="checkbox" defaultValue="" id="flexSwitchCheckedAdres"
                                   name="AdresIzni" onClick={(event) => handleOption(event,!customerState?.AdresIzni)}
                                   checked={customerState.AdresIzni} />
                            <label className="form-check-label" htmlFor="flexSwitchCheckedAdres">
                               Adres
                            </label>
                        </div>     
                    </div>          
                
                    <div className="col-xxl-9">

                    </div>

                    <div className="col-xxl-3">
                        <button className="btn btn-primary p-3" onClick={sendLinkClick} disabled={sendLinkLoading} style={{fontWeight:'normal'}}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" style={{marginRight:7,marginBottom:3}} width="16" height="16" fill="currentColor" className="bi bi-envelope" viewBox="0 0 16 16">
                                                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                                                        </svg>
                                                        {!sendLinkLoading && <span className='indicator-label'>Güncelleme Linki Gönder</span>}
                                                        {sendLinkLoading && (
                                                            <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                            Güncelleme Linki Gönderiliyor...
                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                            </span>
                                                        )} 
                            </button>
                    </div>
                    <div className="col-xxl-9"></div>

                    <div className="col-xxl-3">
                        <button className="btn btn-info p-3" onClick={saveData} disabled={saveDataLoading || customerState.CustomerGuid == "00000000-0000-0000-0000-000000000000"} style={{fontWeight:'normal'}}>
                                                        <svg xmlns="http://www.w3.org/2000/svg"style={{marginRight:7,marginBottom:3}} width="16" height="16" fill="currentColor" className="bi bi-hand-thumbs-up" viewBox="0 0 16 16">
                                                             <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z"/>
                                                        </svg>
                                                        {!saveDataLoading && <span className='indicator-label'>Verileri Kaydet</span>}
                                                        {saveDataLoading && (
                                                            <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                            Veriler kaydediliyor...
                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                            </span>
                                                        )} 
                            </button>
                    </div>
                    <div className="col-xxl-9"></div>
                    <div className="col-xxl-3">
                            <button className="btn btn-success p-3" onClick={updateData} disabled={updateDataLoading || customerState.CustomerGuid == "00000000-0000-0000-0000-000000000000"} style={{fontWeight:'normal'}}>
                                                        <svg style={{ marginRight:3,width: 13,marginBottom:1}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cloud-upload" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                            <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                                        </svg>
                                                        {!updateDataLoading && <span className='indicator-label'>MCFM'e Gönder</span>}
                                                        {updateDataLoading && (
                                                            <span className='indicator-progress' style={{display: 'inline',paddingLeft:10}}>
                                                            Veriler güncelleniyor...
                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                            </span>
                                                        )}
                            </button>
                    </div>
                </div>
            </div> 
        </div>
        {/* end: Card Body */}
    </div>
</div>
    } </>
}